<template>
  <div class="asset-avatar-select-overlay d-flex flex-column"
       @mouseenter="hovering=true"
       @mouseleave="hovering=false">
    <div
      class="img-bg tw-group text-white asset-square-item-image bottom-actions-hover-trigger asset-avatar-overlay-container rounded"
      :style="backgroundImage">

      <video-hover-player v-if="asset.type === 'Video'"
                          :asset-id="asset.objectID"
                          class="tw-rounded-lg"
                          :disable-internal-hover="true"
                          :play="hovering"
                          :thumb="asset.thumb_url"
                          :video="assetVideoUrl"/>

      <a :href="assetPublicUrl(asset)" class="position-absolute w-100 h-100"></a>

      <div class="asset-avatar-overlay rounded"/>

      <div class="tw-absolute tw-right-0 tw-top-0 tw-left-0 tw-max-w-full tw-pointer-events-none">
        <AssetCardTop :asset="asset" :user-slug="userSlug"/>
      </div>

      <div class="d-flex bottom-actions align-items-center justify-content-end tw-pointer-events-none">
        <AssetCardBottom :asset="asset"
                         @preview="$emit('preview', asset)"
                         :projectsUrl="projectsUrl"
                         :projectAssetsUrl="projectAssetsUrl"/>
      </div>
    </div>
  </div>

</template>
<script>

import AddToProject from "../Customers/Dashboard/AddToProject.vue";
import GeneralMixins from "../../mixins/GeneralMixins";
import AssetCardBottom from "./AssetCardBottom.vue";
import AssetCardTop from "./AssetCardTop.vue";

export default {
  mixins: [GeneralMixins],

  data() {
    return {
      hovering: false
    }
  },

  props: [
    'asset',
    'userSlug',
    'projectsUrl',
    'projectAssetsUrl'
  ],

  computed: {
    backgroundImage() {
      return `background-image: url(${this.asset.thumb_url})`;
    },

    assetVideoUrl() {
      return this.asset.video_url;
    },

    isVideo() {
      return this.currentType === "Video"
    },
  },

  components: {AssetCardTop, AssetCardBottom, AddToProject}
}
</script>